import { APP_WILL_NAVIGATE } from '../base/app/actionTypes';
import { CONFERENCE_JOINED, CONFERENCE_LEFT, CONFERENCE_WILL_JOIN, CONFERENCE_WILL_LEAVE } from '../base/conference/actionTypes';
import { CONNECTION_ESTABLISHED, CONNECTION_WILL_CONNECT } from '../base/connection/actionTypes';
import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import { PARTICIPANT_JOINED } from '../base/participants/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { TRACK_ADDED } from '../base/tracks/actionTypes';
import { prestartJoin } from './actions.web';
import Conference from './components/web/Conference';
import { captureJoinLibTimes, noteJoinConference, noteJoinConnection, noteRemoteParticipantJoined, noteRemoteVideoTrack, sendJoinMarks } from './joinMarks.web';
/**
 * The room page's join: it starts at the route decision (prestartJoin) and
 * reports its critical path once (joinMarks.web.ts).
 */
MiddlewareRegistry.register(store => next => action => {
    const result = next(action);
    switch (action.type) {
        case APP_WILL_NAVIGATE: {
            // Dispatched once getRouteToRender has decided, and before the app
            // renders the route: a Conference route without an href is this page
            // entering its room. An href is a page load (the page is leaving); any
            // other component (sign-in redirect, deep link, unsupported browser)
            // joins nothing.
            const route = action.route;
            if (route?.component === Conference && !route.href) {
                store.dispatch(prestartJoin());
            }
            break;
        }
        case CONNECTION_WILL_CONNECT:
            // From the start, so a page that leaves before signaling connects
            // still reports when it began.
            noteJoinConnection(action.connection);
            break;
        case CONNECTION_ESTABLISHED:
            noteJoinConnection(action.connection);
            captureJoinLibTimes();
            break;
        case CONFERENCE_WILL_JOIN:
            noteJoinConference(action.conference, JitsiConferenceEvents.CONNECTION_ESTABLISHED);
            break;
        case CONFERENCE_JOINED:
            captureJoinLibTimes();
            break;
        case PARTICIPANT_JOINED: {
            // The other side: not this page, a screen share, a bot or a gateway
            // (Jibri and observers join hidden and never get here).
            const participant = action.participant;
            if (participant && !participant.local && !participant.fakeParticipant && !participant.botType
                && !participant.isJigasi) {
                noteRemoteParticipantJoined();
            }
            break;
        }
        case TRACK_ADDED: {
            const track = action.track;
            if (track && !track.local && track.mediaType === 'video') {
                noteRemoteVideoTrack(track.jitsiTrack?.getTrack?.()?.id);
            }
            break;
        }
        case CONFERENCE_WILL_LEAVE:
        case CONFERENCE_LEFT:
            sendJoinMarks('leave');
            break;
    }
    return result;
});
